module.exports = __webpack_public_path__ + "img/IMG_6726_L_Black.5cde64c4.jpg";